import { TFunction } from "i18next";
import * as React from "react";

// tslint:disable-next-line:no-var-requires
const styles = require("./LimitsAndClosureNavigationPanel.scss");

interface LimitsAndClosureNavigationProps {
    handleClick: (e: React.BaseSyntheticEvent) => void;
    t: TFunction;
}

const LimitsAndClosureNavigationPanel = ({
    handleClick,
    t
}: LimitsAndClosureNavigationProps) => {
    return (
        <div className={styles.wrapper}>
            <button
                value={"PayInLimitScreen"}
                onClick={handleClick}
                className={styles.navigationBtn}
            >
                {t("PayInLimitBtn")}
            </button>
            <button
                onClick={handleClick}
                value={"LossLimitScreen"}
                className={styles.navigationBtn}
            >
                {t("LossLimitBtn")}
            </button>
            <button
                onClick={handleClick}
                value={"AccountClosureScreen"}
                className={styles.navigationBtn}
            >
                {t("ClosureBtn")}
            </button>
        </div>
    );
};

export default LimitsAndClosureNavigationPanel;
